// BUTTON PARA IR CARGANDO PROJECTS DE 3 EN 3

export default function initLoadMoreProjects() {
  const container = document.querySelector('.layout-projects');
  if (!container) return;

  const btn = document.querySelector('[data-load-more="projects"]');
  if (!btn) return;

  const totalItems = container.querySelectorAll('.col').length;
  const step = parseInt(btn.dataset.step ?? '3', 10);

  // OCULTAR DESDE EL INICIO SI NO HACE FALTA PORQUE HAY 3 ITEMS O MENOS
  if (totalItems <= step) {
    btn.classList.add('d-none');
  }

  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-load-more="projects"]');
    if (!button) return;

    e.preventDefault();

    const section = button.closest('section');
    const itemsContainer = section?.querySelector('.content-items');
    if (!itemsContainer) return;

    const hidden = [...itemsContainer.querySelectorAll('.col.is-hidden')];

    hidden.slice(0, step).forEach(el =>
      el.classList.remove('is-hidden')
    );

    if (itemsContainer.querySelectorAll('.col.is-hidden').length === 0) {
      button.classList.add('d-none');
    }
  });
}